import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  Cart,
  GenerateCheckoutSessionApplicationErrors,
  GenerateCheckoutSessionOptions,
  GenerateCheckoutSessionResponse,
  generateCheckoutSession as universalGenerateCheckoutSession,
} from './payments-platform-v1-checkout-session-checkout-sessions.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/payments' };

export function generateCheckoutSession(
  httpClient: HttpClient
): GenerateCheckoutSessionSignature {
  return (
    cart: NonNullablePaths<
      Cart,
      | `items`
      | `items.${number}.name`
      | `items.${number}.price`
      | `items.${number}.quantity`
      | `items.${number}.subscriptionInfo.subscriptionSettings`
      | `items.${number}.subscriptionInfo.subscriptionSettings.freeTrialPeriod.frequency`
      | `items.${number}.subscriptionInfo.subscriptionSettings.frequency`,
      7
    >,
    options: NonNullablePaths<
      GenerateCheckoutSessionOptions,
      `callbackUrls` | `callbackUrls.thankYouPageUrl`,
      3
    >
  ) =>
    universalGenerateCheckoutSession(
      cart,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GenerateCheckoutSessionSignature {
  /**
   * Creates a Wix-hosted checkout session for the supplied line items and returns its redirect URL
   * and session ID.
   *
   * Each call creates a new, independent session. The method isn't idempotent, so a retry produces
   * an additional session rather than recovering the prior one.
   * @param - Items, quantities, and prices the buyer is paying for, plus optional pre-fill customer details.
   * @returns Response after creating a checkout session.
   */
  (
    cart: NonNullablePaths<
      Cart,
      | `items`
      | `items.${number}.name`
      | `items.${number}.price`
      | `items.${number}.quantity`
      | `items.${number}.subscriptionInfo.subscriptionSettings`
      | `items.${number}.subscriptionInfo.subscriptionSettings.freeTrialPeriod.frequency`
      | `items.${number}.subscriptionInfo.subscriptionSettings.frequency`,
      7
    >,
    options: NonNullablePaths<
      GenerateCheckoutSessionOptions,
      `callbackUrls` | `callbackUrls.thankYouPageUrl`,
      3
    >
  ): Promise<
    GenerateCheckoutSessionResponse & {
      __applicationErrorsType?: GenerateCheckoutSessionApplicationErrors;
    }
  >;
}

export {
  CallbackUrls,
  Cart,
  CheckoutSession,
  CustomerInfo,
  FreeTrialPeriod,
  GenerateCheckoutSessionOptions,
  GenerateCheckoutSessionRequest,
  GenerateCheckoutSessionResponse,
  LineItem,
  PhysicalProperties,
  RegisterCheckoutSessionWebhookRequest,
  RegisterCheckoutSessionWebhookResponse,
  SubscriptionFrequency,
  SubscriptionInfo,
  SubscriptionSettings,
  WebhookType,
} from './payments-platform-v1-checkout-session-checkout-sessions.universal.js';
